// Code reference
// https://stackblitz.com/edit/angular-web-semaphore?file=src%2Fapp%2Fawait-semaphore.ts
export class Semaphore {
    private readonly tasks: (() => void)[] = [];
    count: number;

    constructor(count: number) {
        this.count = count;
    }

    private sched() {
        if (this.count > 0 && this.tasks.length > 0) {
            this.count--;
            let next = this.tasks.shift();
            if (next === undefined) {
                throw Error("Unexpected undefined value in tasks list");
            }
            next();
        }
    }

    public acquire() {
        return new Promise<() => void>((res) => {
            var task = () => {
                var released = false;
                res(() => {
                    if (!released) {
                        released = true;
                        this.count++;
                        this.sched();
                    }
                });
            };
            if (this.count !== 0){
                this.tasks.push(task);
            }
            setTimeout(this.sched.bind(this));
        });
    }

    public use<T>(f: () => Promise<T>) {
        return this.acquire()
            .then(release => {
                return f()
                    .then((res) => {
                        release();
                        return res;
                    })
                    .catch((err) => {
                        release();
                        throw err;
                    });
            });
    }
}